import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../../environments/environment';
import { Observable } from 'rxjs';
import { MetodosPago } from '../../../entities/MetodosPago/MetodosPago';

@Injectable({
  providedIn: 'root'
})
export class MetodosPagoService {

  constructor(private http:HttpClient) { }

  registrarMetodoPago(modelo){
    return this.http.post(environment.API_SECURITY+'/api/MetodosPago',modelo)
  }

  obtenerMetodosPago():Observable<MetodosPago[]>{
    return this.http.get<MetodosPago[]>(environment.API_SECURITY+'/api/MetodosPago')
  }
  
  actualizarMetodoDefault(idKonnecta):Observable<MetodosPago>{
    return this.http.get<MetodosPago>(environment.API_SECURITY+'/api/MetodosPago/'+idKonnecta)
  }

  eliminarMetodoPago(idKonnecta){
    return this.http.delete(environment.API_SECURITY+'/api/MetodosPago/'+idKonnecta)
  }
  
}
